var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63067 0.287997C7.76731 -0.0405203 8.23269 -0.0405213 8.36933 0.287996L10.0222 4.26198C10.0798 4.40047 10.21 4.4951 10.3596 4.50709L14.6498 4.85103C15.0045 4.87947 15.1483 5.32207 14.8781 5.55354L11.6094 8.35354C11.4954 8.45112 11.4457 8.60423 11.4805 8.75014L12.4791 12.9367C12.5617 13.2828 12.1852 13.5563 11.8816 13.3709L8.2085 11.1274C8.0805 11.0492 7.9195 11.0492 7.7915 11.1274L4.11845 13.3709C3.81481 13.5563 3.43831 13.2828 3.52086 12.9367L4.51951 8.75014C4.55431 8.60423 4.50456 8.45112 4.39065 8.35354L1.12193 5.55354C0.851716 5.32207 0.995526 4.87947 1.35019 4.85103L5.64044 4.50709C5.78995 4.4951 5.9202 4.40047 5.9778 4.26198L7.63067 0.287997Z",
    fill: "#D0D5DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "12bc089b1adac50e797958329d2223e0.svg";
export { ForwardRef as ReactComponent };